export default __webpack_public_path__ + "static/media/pedro-lima-HtwsbbClBOs-unsplash.619153b5.jpg";